import { Maximize2 } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgArrowsExpand3 = mkIcon(Maximize2);